import React, { useEffect, useRef, useState } from "react"
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Target from "../../components/Cursor/target";
import PageTransition from "../../components/page-transition";
import Layout from "../../components/layout"
import SEO from "../../components/seo"

import worksData from "../../data/works";
import { EVENTS, getGlobals } from "../../helpers/globals";
import '../../styles/works.scss';

gsap.registerPlugin(ScrollTrigger);

const FilterHeader = () => (
  <div className="hp-works-filter-header">
    <h1>My Works</h1>
  </div>
);

const WorkItem = (props: any) => {
  const elemRef = useRef(null);
  const imgRef = useRef(null);
  useEffect(() => {
    gsap.to(imgRef.current, {
      transform: 'translate3d(0, -20%, 0)',
      duration: 1,
      scrollTrigger: {
        trigger: elemRef.current,
        scrub: true
      }
    });
  }, []);

  const toPage = `/works/cab?id=${props.id}`;

  return (
    <Target cursorText="view case" cursorColor={props.cursor}>
      <PageTransition to={toPage}>
      <div className="hp-works-item" ref={elemRef}>
        <div className="hp-works-item-image">
          <img ref={imgRef} className="hp-work-image" src={`./../${props.image}`} />
        </div>
        <div className="hp-works-item-content">
          <p>
            <b>{props.header}</b>
            {' '}-{' '}
            {props.titleLine1} {props.titleLine2}
          </p>
        </div>
      </div>
    </PageTransition>
    </Target>
  );
}

const WorksGridLeft = ({ works }) => {
  return (
    <div className="hp-works-grid-left">
      {works.map(work => <WorkItem key={work.id} {...work} />)}
    </div>
  )
}

const WorksGridRight = ({ works }) => {
  return (
    <div className="hp-works-grid-right">
      {works.map(work => <WorkItem key={work.id} {...work} />)}
    </div>
  )
}

const WorksGrid = () => {
  const [canLoad, setCanLoad] = useState(false);
  const momentumScrollContext = useRef(getGlobals('SMOOTH_SCROLL_CONTEXT'));
  const scroller = useRef(null);

  const setUpScrollProxy = () => {
    scroller.current = document.querySelector(`#hp-momentum-scroll`);
    ScrollTrigger.scrollerProxy(scroller.current, {
      scrollTop (value) {
        if (arguments.length) {
          if (momentumScrollContext.current) {
            momentumScrollContext.current.scrollTop = value;
          }
        }
        return momentumScrollContext.current?.scrollTop;
      }
    });
    momentumScrollContext.current?.addListener(ScrollTrigger.update);
    ScrollTrigger.defaults({ scroller: scroller.current });
    initScrollAnims();
  }

  const initScrollAnims = () => {
    setCanLoad(true);
  };

  useEffect(() => {
    window.addEventListener(EVENTS.onSmoothScrollInit, () => {
      momentumScrollContext.current = getGlobals('SMOOTH_SCROLL_CONTEXT');
      setUpScrollProxy();
    });

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener(EVENTS.onSmoothScrollInit, () => {});
      }
    }
  }, []);

  const leftWorks = worksData.filter((work, index) => index % 2 === 0);
  const rightWorks = worksData.filter((work, index) => index % 2 !== 0);

  return (
    <div className="hp-works-grid">
      {
        canLoad ? (
          <>
            <WorksGridLeft works={leftWorks} />
            <WorksGridRight works={rightWorks} />
          </>
        ) : null
      }
    </div>
  )
}

const WorksPage = () => (
  <Layout>
    <SEO title="Works" />
    <FilterHeader />
    <WorksGrid />
  </Layout>
);

export default WorksPage
